function cov_w4lqeeebg() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Logo.tsx";
  var hash = "c3ef9586d94e4b241c459d0a612d625470e809a8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Logo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c3ef9586d94e4b241c459d0a612d625470e809a8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_w4lqeeebg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_w4lqeeebg();
var Icon = (cov_w4lqeeebg().s[0]++, {
  name: 'logo',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.072 4.635c0-2.908-.5-4.113-1.874-4.113-1.212 0-1.824.845-1.824 3.778 0 2.895.475 4.088 1.874 4.088 1.237 0 1.824-.833 1.824-3.753ZM0 4.561C0 1.292 2.262 0 4.273 0c2.15 0 4.173 1.28 4.173 4.362 0 3.293-2.261 4.548-4.273 4.548C2.024 8.91 0 7.543 0 4.56Zm8.005 6.978-.995-1.313a.423.423 0 0 0-.337-.156h-4.9a.423.423 0 0 0-.337.156L.441 11.54a.23.23 0 0 0-.048.14v.2c0 .067.054.121.122.121h7.417a.121.121 0 0 0 .122-.121v-.2a.23.23 0 0 0-.049-.14Z\" fill=\"currentColor\"/>"
});
export default Icon;